import React from 'react';
import styled from 'styled-components';
import Java from './Java';
import Python from './Python';
import CPlus from './C++';
import Golang from './Golang';
import SpringBoot from './SpringBoot';
import Csharp from './Csharp';

export default function Code({ currentTag, brokerServiceUrl }) {
  return (
    <Root>
      {currentTag === 'Java' && <Java brokerServiceUrl={brokerServiceUrl} />}
      {currentTag === 'Python' && <Python brokerServiceUrl={brokerServiceUrl} />}
      {currentTag === 'Golang' && <Golang brokerServiceUrl={brokerServiceUrl} />}
      {currentTag === 'C++' && <CPlus brokerServiceUrl={brokerServiceUrl} />}
      {currentTag === 'C#' && <Csharp brokerServiceUrl={brokerServiceUrl} />}
      {currentTag === 'Spring Boot' && <SpringBoot brokerServiceUrl={brokerServiceUrl} />}
    </Root>
  );
}

const Root = styled.div`
  margin-top: 20px;
`;
